var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.thanksToPresent)?_c('span',[_vm._v("\n  thanks to "),_vm._l((_vm.thanksTo),function(lifeArea,index){return _c('span',[_c('LifeArea',{attrs:{"lifeArea":lifeArea}}),_vm._v(_vm._s(_vm.delimiter(index))+"\n  ")],1)})],2):_c('span')
}
var staticRenderFns = []

export { render, staticRenderFns }